// VIDEO LAZYLOAD
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

$(document).ready(function () {
  $('[data-open-sidebar]').on('click', function () {
    $('.page-sidebar, .page-content').toggleClass('sidebar-open');
    $(this).find('.text').text($('.page-sidebar').hasClass('sidebar-open') ? 'Ocultar Filtros' : 'Mostrar Filtros');
  });
});

/* Color swatch nos cards de coleção */

function normalizeQuickShopValue(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function getQuickShopSelectedSize($form) {
  const $checkedVisibleOption = $form
    .find('.selector-wrapper:not([style*="display: none"]) input.single-option:checked')
    .first();

  if ($checkedVisibleOption.length) {
    return $checkedVisibleOption.val();
  }

  const $checkedSizeOption = $form
    .find('.selector-wrapper input.single-option:checked')
    .filter(function () {
      const $wrapper = $(this).closest('.selector-wrapper');
      const labelText = normalizeQuickShopValue($wrapper.find('.form-label').text());

      return (
        labelText.includes('tamanho') ||
        labelText.includes('size') ||
        labelText.includes('numeracao') ||
        labelText.includes('numero')
      );
    })
    .first();

  if ($checkedSizeOption.length) {
    return $checkedSizeOption.val();
  }

  return null;
}

function getSizeOptionIndexFromProduct(productData, fallbackPosition) {
  if (fallbackPosition && !Number.isNaN(Number(fallbackPosition))) {
    return Number(fallbackPosition) - 1;
  }

  if (!productData || !productData.options) {
    return 0;
  }

  const options = productData.options;

  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    const optionName = typeof option === 'string' ? option : option.name;
    const normalizedOptionName = normalizeQuickShopValue(optionName);

    if (
      normalizedOptionName.includes('tamanho') ||
      normalizedOptionName.includes('size') ||
      normalizedOptionName.includes('numeracao') ||
      normalizedOptionName.includes('numero')
    ) {
      return i;
    }
  }

  return 0;
}

function fetchProductByHandle(handle) {
  if (!handle) return Promise.reject('Handle não informado.');

  window.__quickShopProductCache = window.__quickShopProductCache || {};

  if (window.__quickShopProductCache[handle]) {
    return Promise.resolve(window.__quickShopProductCache[handle]);
  }

  return fetch(`/products/${handle}.js`)
    .then(function (response) {
      if (!response.ok) {
        throw new Error(`Erro ao buscar produto: ${handle}`);
      }

      return response.json();
    })
    .then(function (productData) {
      window.__quickShopProductCache[handle] = productData;
      return productData;
    });
}

function findVariantBySelectedSize(productData, selectedSize, sizePosition) {
  if (!productData || !productData.variants || !selectedSize) {
    return null;
  }

  const normalizedSelectedSize = normalizeQuickShopValue(selectedSize);
  const sizeIndex = getSizeOptionIndexFromProduct(productData, sizePosition);

  let matchedVariant = productData.variants.find(function (variant) {
    const optionValue = variant.options && variant.options[sizeIndex];

    return variant.available && normalizeQuickShopValue(optionValue) === normalizedSelectedSize;
  });

  if (!matchedVariant) {
    matchedVariant = productData.variants.find(function (variant) {
      if (!variant.available || !variant.options) return false;

      return variant.options.some(function (optionValue) {
        return normalizeQuickShopValue(optionValue) === normalizedSelectedSize;
      });
    });
  }

  return matchedVariant || null;
}

function updateQuickShopFormVariant($form, variantId) {
  if (!variantId) return;

  const variantIdString = String(variantId);

  const $select = $form.find('select[name="id"]').first();
  const $input = $form.find('input[name="id"]').first();

  if ($select.length) {
    let $option = $select.find(`option[value="${variantIdString}"]`);

    if (!$option.length) {
      $select.append(`<option value="${variantIdString}" data-value="${variantIdString}">${variantIdString}</option>`);
      $option = $select.find(`option[value="${variantIdString}"]`);
    }

    $select.val(variantIdString);
    $option.prop('selected', true);
    $select.trigger('change');
  }

  if ($input.length) {
    $input.val(variantIdString).trigger('change');
  }
}

function refreshAndOpenSidebarCart(callback) {
  const openCartSidebar = function () {
    $('[data-cancel-quickshop-popup]').trigger('click');

    const $cartTrigger = $(
      '[data-cart-sidebar], ' +
      '[data-open-cart-sidebar], ' +
      '[data-cart-drawer], ' +
      '[data-open-cart], ' +
      '[data-cart-preview], ' +
      '[data-cart-toggle], ' +
      '.header__icon--cart, ' +
      '.cart-icon, ' +
      '.site-header__cart, ' +
      '.header-cart, ' +
      'a[href="/cart"], ' +
      'a[href*="/cart"]'
    ).filter(function () {
      return !$(this).closest('form').length;
    }).first();

    if ($cartTrigger.length) {
      $cartTrigger.trigger('click');
    }

    $('body').addClass('cart-sidebar-show cart-drawer-show cart-show open-cart show-cart');

    $('.halo-cart-sidebar, .cart-sidebar, .cart-drawer, .previewCart, .previewCart-wrapper, [data-cart-sidebar], [data-cart-drawer]')
      .addClass('is-open active show open');

    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:drawer:open'));
    document.dispatchEvent(new CustomEvent('halo:cart:open'));

    if (typeof callback === 'function') {
      callback();
    }
  };

  const afterCartUpdated = function (cart) {
    if (cart && typeof cart.item_count !== 'undefined') {
      $('[data-cart-count], .cart-count, .header__icon--cart .count, .cart-icon .count, .cart-count-bubble span')
        .text(cart.item_count)
        .attr('data-cart-count', cart.item_count);
    }

    setTimeout(openCartSidebar, 200);
  };

  if (
    typeof Shopify !== 'undefined' &&
    typeof Shopify.getCart === 'function' &&
    window.halo &&
    typeof window.halo.updateSidebarCart === 'function'
  ) {
    Shopify.getCart(function (cart) {
      window.halo.updateSidebarCart(cart);
      afterCartUpdated(cart);
    });

    return;
  }

  fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
        window.halo.updateSidebarCart(cart);
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart } }));

      afterCartUpdated(cart);
    })
    .catch(function () {
      openCartSidebar();
    });
}

$(document).on('click', '.thumb-color-meta', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $clicked = $(this);
  const $containerColor = $clicked.closest('.colors-list-thumbs');
  const $card = $clicked.closest('.card');
  const $productItem = $clicked.closest('.product-item');

  if (!$card.length) return;

  const clickedHandle = $clicked.attr('data-handle');
  const clickedUrl = $clicked.attr('data-url-product') || $clicked.attr('data-product-url');
  const clickedProductUrl = $clicked.attr('data-product-url') || clickedUrl;
  const clickedImage = $clicked.attr('data-image-feature');
  const clickedSecondImage = $clicked.attr('data-second-image');
  const clickedTitle = $clicked.attr('data-product-title');
  const clickedPrice = $clicked.attr('data-price');
  const clickedPriceHtml = $clicked.attr('data-price-html');
  const clickedVariantId = $clicked.attr('data-variant-id');
  const clickedSizePosition = $clicked.attr('data-index-size');

  const originalProductHandle =
    $clicked.closest('.container-colorlist').attr('data-card-product-handle') ||
    $clicked.closest('[data-product-handle]').attr('data-product-handle') ||
    clickedHandle;

  window.__quickShopSelectedColorByOriginalHandle =
    window.__quickShopSelectedColorByOriginalHandle || {};

  window.__quickShopSelectedColorByOriginalHandle[originalProductHandle] = {
    handle: clickedHandle,
    variantId: clickedVariantId,
    sizePosition: clickedSizePosition,
    productUrl: clickedProductUrl
  };

  console.log('✅ Cor salva para compra rápida:', {
    originalProductHandle,
    selectedHandle: clickedHandle,
    selectedVariantId: clickedVariantId,
    selectedSizePosition: clickedSizePosition
  });

  if (!clickedHandle || !clickedUrl) return;

  console.group('🟣 CLICK SWATCH CARD');
  console.log('Card atualizado:', $card[0]);
  console.log('Handle clicado:', clickedHandle);
  console.log('URL clicada:', clickedUrl);
  console.log('Imagem principal:', clickedImage);
  console.log('Segunda imagem:', clickedSecondImage);
  console.log('Título:', clickedTitle);
  console.log('Preço:', clickedPrice);
  console.log('Variant ID:', clickedVariantId);
  console.log('Posição da opção tamanho:', clickedSizePosition);

  $containerColor.find('.thumb-color-meta').removeClass('active').removeAttr('aria-current');
  $clicked.addClass('active').attr('aria-current', 'true');

  const $quickShopScope = $clicked.closest('.product-item, .card-product, .card, .product-card');

  $quickShopScope
    .find('form.variants[action*="/cart/add"], form[action*="/cart/add"]')
    .attr('data-selected-product-handle', clickedHandle)
    .attr('data-selected-size-position', clickedSizePosition || '')
    .attr('data-selected-variant-id', clickedVariantId || '');

  $card.attr('data-selected-product-handle', clickedHandle);
  $card.attr('data-selected-product-url', clickedProductUrl);
  $card.attr('data-selected-size-position', clickedSizePosition || '');

  if (clickedVariantId) {
    $card.attr('data-selected-variant-id', clickedVariantId);
  }

  if ($productItem.length) {
    $productItem.attr('data-product-handle', clickedHandle);
    $productItem.attr('data-selected-product-handle', clickedHandle);
    $productItem.attr('data-selected-product-url', clickedProductUrl);
    $productItem.attr('data-selected-size-position', clickedSizePosition || '');

    if (clickedVariantId) {
      $productItem.attr('data-variant-id', clickedVariantId);
      $productItem.attr('data-selected-variant-id', clickedVariantId);
    }
  }

  $card.find('a[href*="/products/"]').each(function () {
    const $link = $(this);

    if ($link.closest('.colors-list-thumbs').length) return;

    $link.attr('href', clickedUrl);
  });

  if (clickedTitle) {
    const $titleLink = $card.find(
      '.card-title a, .card__heading a, .card-information a[href*="/products/"], a.full-unstyled-link'
    ).first();

    if ($titleLink.length) {
      $titleLink.text(clickedTitle);
      $titleLink.attr('href', clickedUrl);
    } else {
      const $titleElement = $card.find(
        '.card-title, .card__heading, .card-information__text, .card-product__title'
      ).first();

      if ($titleElement.length) {
        $titleElement.text(clickedTitle);
      }
    }
  }

  if (clickedImage) {
    const $images = $card.find('.card-product img, .card__media img, .media img, img.motion-reduce').filter(function () {
      return !$(this).closest('.colors-list-thumbs').length;
    });

    $images.each(function (index) {
      const $image = $(this);
      const nextImage = index === 1 && clickedSecondImage ? clickedSecondImage : clickedImage;

      $image.attr('src', nextImage);
      $image.attr('srcset', '');

      if (clickedTitle) {
        $image.attr('alt', clickedTitle);
      }
    });
  }

  if (clickedPriceHtml) {
    const $currentPriceBlock = $card.find(
      '.price-with-installments, .card-price, .price'
    ).first();

    if ($currentPriceBlock.length) {
      $currentPriceBlock.replaceWith(clickedPriceHtml);
    }
  } else if (clickedPrice) {
    const $priceRegular = $card.find(
      '.price .price-item--regular, .price__regular .price-item, .card-price, .price-item'
    ).first();

    if ($priceRegular.length) {
      $priceRegular.text(clickedPrice);
    }
  }

  if (clickedVariantId) {
    $card.find('input[name="id"]').val(clickedVariantId);

    $card.find('[data-variant-id]').each(function () {
      $(this).attr('data-variant-id', clickedVariantId);
    });

    $card.find('[data-product-id]').each(function () {
      $(this).attr('data-product-id', clickedVariantId);
    });

    $card.find('form[action*="/cart/add"]').each(function () {
      const $form = $(this);
      const $input = $form.find('input[name="id"]');

      if ($input.length) {
        $input.val(clickedVariantId);
      }
    });
  }

  window.sliderNavGrid?.();
  window.updateSlideGridProduct?.();

  console.log('Handle ativo final:', $containerColor.find('.thumb-color-meta.active').attr('data-handle'));
  console.groupEnd();
});

function getQuickShopSelectedColorData($form) {
  window.__quickShopSelectedColorByOriginalHandle =
    window.__quickShopSelectedColorByOriginalHandle || {};

  const originalHandle = $form.attr('data-current-product-handle');

  if (!originalHandle) {
    return null;
  }

  const selectedData = window.__quickShopSelectedColorByOriginalHandle[originalHandle];

  if (!selectedData || !selectedData.handle) {
    return null;
  }

  if (selectedData.handle === originalHandle) {
    return null;
  }

  return {
    originalHandle: originalHandle,
    selectedHandle: selectedData.handle,
    selectedVariantId: selectedData.variantId,
    selectedSizePosition: selectedData.sizePosition
  };
}

function runCustomQuickShopAdd(form, event) {
  const $form = $(form);
  const colorData = getQuickShopSelectedColorData($form);

  if (!colorData) {
    return false;
  }

  const selectedSize = getQuickShopSelectedSize($form);

  if (!selectedSize) {
    return false;
  }

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const $submitButton = $form.find('[type="submit"], [data-btn-addToCart]').first();

  $submitButton.addClass('is-loading').attr('aria-busy', 'true');

  console.log('🟡 Interceptando compra rápida:', {
    originalHandle: colorData.originalHandle,
    selectedHandle: colorData.selectedHandle,
    selectedSize: selectedSize,
    selectedSizePosition: colorData.selectedSizePosition
  });

  fetchProductByHandle(colorData.selectedHandle)
    .then(function (productData) {
      const matchedVariant = findVariantBySelectedSize(
        productData,
        selectedSize,
        colorData.selectedSizePosition
      );

      if (!matchedVariant) {
        console.warn('❌ Nenhuma variante encontrada para:', {
          handle: colorData.selectedHandle,
          tamanho: selectedSize,
          produto: productData
        });

        $submitButton.removeClass('is-loading').removeAttr('aria-busy');
        alert('Não encontramos esse tamanho para a cor selecionada.');
        return null;
      }

      console.log('✅ Variante correta encontrada:', {
        productTitle: productData.title,
        handle: colorData.selectedHandle,
        tamanho: selectedSize,
        variantId: matchedVariant.id,
        variantTitle: matchedVariant.title
      });

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: matchedVariant.id,
          quantity: 1
        })
      });
    })
    .then(function (response) {
      if (!response) return null;

      if (!response.ok) {
        return response.json().then(function (data) {
          throw data;
        });
      }

      return response.json();
    })
    .then(function (data) {
      if (!data) return;

      console.log('✅ Produto adicionado ao carrinho:', data);

      $submitButton.removeClass('is-loading').removeAttr('aria-busy');

      refreshAndOpenSidebarCart();
    })
    .catch(function (error) {
      console.error('❌ Erro ao adicionar variante correta:', error);

      $submitButton.removeClass('is-loading').removeAttr('aria-busy');

      const message =
        error && error.description
          ? error.description
          : 'Não foi possível adicionar essa variação ao carrinho. Tente novamente.';

      alert(message);
    });

  return true;
}

/**
 * Intercepta o clique antes do JS original do tema.
 */
document.addEventListener(
  'click',
  function (event) {
    const button = event.target.closest(
      'form.variants[action*="/cart/add"] [type="submit"], form.variants[action*="/cart/add"] [data-btn-addToCart], form[action*="/cart/add"] [data-btn-addToCart]'
    );

    if (!button) {
      return;
    }

    const form = button.closest('form.variants[action*="/cart/add"], form[action*="/cart/add"]');

    if (!form) {
      return;
    }

    runCustomQuickShopAdd(form, event);
  },
  true
);

/**
 * Fallback para quando o tema usa submit nativo.
 */
document.addEventListener(
  'submit',
  function (event) {
    const form = event.target;

    if (!form.matches('form.variants[action*="/cart/add"], form[action*="/cart/add"]')) {
      return;
    }

    runCustomQuickShopAdd(form, event);
  },
  true
);

function updateArrowVisibility() {
  document.querySelectorAll('.container-colorlist').forEach(function (container) {
    var colorlist = container.querySelector('.colors-list-thumbs');
    var arrow = container.querySelector('.arrow');

    if (arrow) {
      var totalWidth = 0;

      colorlist.querySelectorAll('.thumb-color-meta').forEach(function (color) {
        totalWidth += color.offsetWidth + parseFloat(window.getComputedStyle(color).marginRight);
      });

      if (totalWidth > colorlist.offsetWidth) {
        arrow.style.display = 'block';
      } else {
        arrow.style.display = 'none';
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.__customMobileSubmenuInit) return;
  window.__customMobileSubmenuInit = true;

  document.addEventListener('click', function (event) {
    if (window.innerWidth > 1024) return;

    const lv1Trigger = event.target.closest(
      '.site-nav-mobile[data-navigation-mobile] .js-mobile-submenu-toggle'
    );

    const lv2Trigger = event.target.closest(
      '.site-nav-mobile[data-navigation-mobile] .js-mobile-submenu-toggle-2'
    );

    const trigger = lv1Trigger || lv2Trigger;
    if (!trigger) return;

    const item = trigger.closest(lv1Trigger ? '.menu-lv-1' : '.menu-lv-2');
    if (!item) return;

    const submenu = lv1Trigger
      ? item.querySelector(':scope > .header__submenu.expanded-menu--lv-2.mobile-only')
      : item.querySelector(':scope > .site-nav-list-dropdown > .header__submenu.expanded-menu--lv-3.mobile-only');

    if (!submenu) return;

    event.preventDefault();
    event.stopPropagation();

    const isOpen = item.classList.contains('is-open');

    const siblings = Array.from(item.parentElement.children).filter((el) => el !== item);

    siblings.forEach((sibling) => {
      sibling.classList.remove('is-open');

      sibling.querySelectorAll('.menu-lv-2.is-open').forEach((child) => {
        child.classList.remove('is-open');
      });
    });

    if (isOpen) {
      item.classList.remove('is-open');

      item.querySelectorAll('.menu-lv-2.is-open').forEach((child) => {
        child.classList.remove('is-open');
      });
    } else {
      item.classList.add('is-open');
    }
  });
});